<template>
  <div class="select-tree">
    <el-select
      v-model="selectVal"
      placeholder="请选择"
      filterable
      :filter-method="selectTreeList"
      :disabled="disabled"
    >
      <el-option
        :value="treeDataValue"
        class="selectTree"
        style="height: auto"
      >
        <el-tree
          ref="tree"
          node-key="id"
          :filter-node-method="filterNode"
          :data="departmentList"
          :props="defaultProps"
          show-checkbox
          check-strictly
          :highlight-current="true"
          :default-expanded-keys="[id]"
          :current-node-key="id"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          @check-change="handleNodeCheck"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span v-if="data.children" class="iconfont" style="margin-right: 16px">
              <img :src="data.img">
            </span>
            <span v-if="!data.children&&!data.image" class="children-img" style="margin-right: 16px">
              <img :src="data.img">
            </span>
            <span v-if="data.image" style="margin-right:10px;">
              <img class="select-img" :src="data.image">
            </span>
            <span>{{ node.label}}</span>          
          </span>
        </el-tree>
      </el-option>
    </el-select>
    
  </div>
</template>

<script>
export default {
  props: {
    departmentId: {
      type: Object,
    },
    departmentList: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      selectVal: this.departmentId.name,
      treeDataValue: '',
      defaultProps: {
        children: "subList",
        label: "departmentName"
      },
      id: this.departmentId.id,
    }
  },

  created() {
    this.mapId(this.departmentList, this.id)
    this.departmentList.map(i => {
      this.getLeafKeys(i)
    })
    /* select 回填显示 */
    this.$nextTick(() => {
      this.$refs.tree.setCheckedKeys([this.id]);
    })
  },
  mounted() {
    this.$bus.on('getHeadData', (v) => {
      v.map(i => {
        this.getLeafKeys(i)
      })
    })
  },

  methods: {
    selectTreeList(val) {
      this.$refs.tree.filter(val);
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.departmentName.indexOf(value) !== -1;
    },

    /* 点击变更部门 */
    handleNodeClick(data) {
      this.id = Number(data.id);
      this.mapId(this.departmentList, data.id)
    },

    mapId(child, id) {
      child.map(i => {
        if (i.id === id) {
          if (i.level === 1) {
            i.img = require('../assets/tree/first-high.png')
          } else {
            i.img = require('../assets/tree/second-high.png')
          }
          i.threeSpotImg = require('../assets/tree/three-spot-high.png')
        } else {
          if (i.level === 1) {
            i.img = require('../assets/tree/first.png')
          } else {
            i.img = require('../assets/tree/second.png')
          }
          i.threeSpotImg = require('../assets/tree/three-spot.png')
        }
        if (i.subList && i.subList.length > 0) {
          this.mapId(i.subList, id);
        }
      })
    },

    /* 
      通过递归的形式，获取最后一级的id，
     */
    getLeafKeys(node) {
      /* 
        如果当前 node 节点不包含 children 属性，
        则是三级节点
       */
      if (node.zzdCode == undefined) {
        /* 除了最后一级所有节点disabled为true */
        node.disabled = true;
      }
      node.subList.forEach(item => this.getLeafKeys(item));
    },

    handleNodeCheck(item, node, self) {
      if (node === true) {
        this.id = item.id;
        this.$refs.tree.setCheckedKeys([item.id]);
        this.mapId(this.departmentList, item.id)
        this.treeDataValue = item.id
        this.selectVal = item.departmentName
        this.$emit('selectTreeNodeList', item)
      }
    },
  }
}
</script>

<style lang='scss'>
.selectTree {
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner{
      display: inline-block;
    }
    .el-checkbox.is-disabled .el-checkbox__inner{
      display: none;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
    }
  }
}
.selectTree.hover, .selectTree:hover {
  background: transparent;
}
.select-img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.select-tree {
  .el-tree-node__content {
    font-size: $fs-small-l;
    color: $color-grey;
  }
  .search {
    margin-bottom: 12px;
  }
}
</style>
